var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnickpicLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 96,
    viewBox: "0 0 98 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49,
    cy: 48,
    rx: 48.96,
    ry: 48,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6263 18.7822V28.4268C40.6263 28.4268 33.0649 28.9983 33.1862 35.8021C33.0928 37.5835 33.6898 39.3338 34.8577 40.7016C36.0255 42.0695 37.6778 42.9539 39.4829 43.1773H57.7965C57.7965 43.1773 74.0595 43.4121 73.8244 61.3329C73.6258 76.1476 56.6467 77.217 56.6467 77.217V67.5724C56.6467 67.5724 63.8484 66.9967 64.0868 60.7656C64.1975 59.7509 64.0863 58.7249 63.7608 57.7557C63.4352 56.7865 62.9026 55.8965 62.1986 55.1449C61.4946 54.3933 60.6353 53.7975 59.678 53.3971C58.7206 52.9968 57.6873 52.801 56.6467 52.823H38.9096C38.9096 52.823 23.3155 51.4241 23.455 35.8021C23.5925 20.4768 37.7974 18.8128 40.6263 18.7822Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnickpicLogo);
export default __webpack_public_path__ + "static/media/snickpicLogo.7aa19ec3c4bacf5aa205a04acdc02e4e.svg";
export { ForwardRef as ReactComponent };